import { usePageTemplate } from '@faceup/ui'
import type { ChannelPageType } from '@faceup/utils'

type PageData = {
  __typename: string
  type: ChannelPageType
  content?: string | null
  title?: string | null
}

type UseFilledPageProps = {
  pages: readonly PageData[]
  step: ChannelPageType
}

export const useFilledPage = ({ pages, step }: UseFilledPageProps) => {
  const { fillObject } = usePageTemplate()

  const currentPage = pages.find(page => (page.__typename === 'Page' ? false : page.type === step))

  if (!currentPage) {
    return null
  }

  // @ts-expect-error TODO
  return currentPage.__typename === 'ChannelPage' ? fillObject(currentPage) : undefined
}
